import script from "./ContactSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactSection.vue?vue&type=script&lang=ts&setup=true"

import "./ContactSection.vue?vue&type=style&index=0&id=1db776b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db776b4"]])

export default __exports__